<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="RELATÓRIOS RECEBIMENTOS EXTRA ORÇAMENTÁRIOS"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/print.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <button type="submit" (click)="gerarRelatorio()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="20" width="20">
          Gerar PDF
        </button>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <form>
      <div class="row">
        <div class="col-md-5">
          <img src="assets/img/global/date_magnify.png" alt="data">
          <label for="exercicio">Opção</label>
          <select [(ngModel)]="relatorio" name="selectMes" style="border: none !important" style="font-weight: bold;"
            class="custom-select custom-select-sm">
            <option [selected]="item.id === relatorio" [value]="item.value" *ngFor="let item of listaRelatorio">
              {{item.label}}
            </option>
          </select>
        </div>
        <div class="offset-2 col-5" style="text-align: right">

        </div>
      </div>
      <div class="row mt-4">
        <div class="form-group col-md-2">
          <label for="dataInicial">Período</label>
          <input [unmask]="false" [imask]="{mask: '00/00/0000'}" [(ngModel)]="dataInicial" type="text"
            class="form-control" id="dataInicial" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group col-0" style="margin-top: 10px">
          <br />
          <span>à</span>
        </div>
        <div class="form-group col-md-2">
          <label for="dataFinal">&nbsp;</label>
          <input [unmask]="false" [imask]="{mask: '00/00/0000'}" [(ngModel)]="dataFinal" type="text"
            class="form-control" id="dataFinal" [ngModelOptions]="{standalone: true}">
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <img src="assets/img/global/table_sort_filter.png" alt="img" height="22" width="22"> <span
            class="text-black-50 font-weight-light"> Filtros </span>
          <hr />
          <div class="row mt-4">
            <div class="form-group col-md-12 m-0">
              <label for="despesa">
                <div class="checkbox checbox-switch switch-primary  m-0">
                  <label>
                    <input [(ngModel)]="filtroPlano" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por conta contábil
                  </label>
                </div>
              </label>
              <div *ngIf="filtroPlano" class="mb-2">
                <p-autoComplete id="plano" [(ngModel)]="plano" [forceSelection]="true" [autoHighlight]="true"
                  [ngModelOptions]="{standalone: true}" [field]="planoAutoComplete.conversor"
                  [suggestions]="planoAutoComplete.lista" (completeMethod)="planoAutoComplete.filtrar($event)"
                  inputStyleClass="form-control form-control-sm" [style]="{ width: '100%' }">
                  <ng-template let-plano pTemplate="item">
                    {{plano.codigo}} {{plano.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="conta">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroConta" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por conta bancária
                  </label>
                </div>
              </label>
              <div *ngIf="filtroConta" class="mb-2">
                <p-autoComplete id="conta" [(ngModel)]="conta" [forceSelection]="true" [autoHighlight]="true"
                  [ngModelOptions]="{standalone: true}" [field]="contaAutoComplete.conversor"
                  [suggestions]="contaAutoComplete.lista" (completeMethod)="contaAutoComplete.filtrar($event)"
                  inputStyleClass="form-control form-control-sm" [style]="{ width: '100%' }">
                  <ng-template let-conta pTemplate="item">
                    {{conta.numero_conta}}-{{conta.digito_conta}} {{conta.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="recurso">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroRecurso" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por fonte de recurso
                  </label>
                </div>
              </label>
              <div *ngIf="filtroRecurso" class="mb-2">
                <p-autoComplete id="recurso" [(ngModel)]="recurso" [forceSelection]="true" [autoHighlight]="true"
                  [ngModelOptions]="{standalone: true}" [field]="recursoAutoComplete.conversor"
                  [suggestions]="recursoAutoComplete.lista" (completeMethod)="recursoAutoComplete.filtrar($event)"
                  inputStyleClass="form-control form-control-sm" [style]="{ width: '100%' }">
                  <ng-template let-recurso pTemplate="item">
                    {{recurso.codigo}} {{recurso.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="aplicacao">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroAplicacao" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por aplicação de recurso
                  </label>
                </div>
              </label>
              <div *ngIf="filtroAplicacao" class="mb-2">
                <p-autoComplete id="aplicacao" [(ngModel)]="aplicacao" [forceSelection]="true" [autoHighlight]="true"
                  [ngModelOptions]="{standalone: true}" [field]="aplicacaoAutoComplete.conversor"
                  [suggestions]="aplicacaoAutoComplete.lista" (completeMethod)="aplicacaoAutoComplete.filtrar($event)"
                  inputStyleClass="form-control form-control-sm" [style]="{ width: '100%' }">
                  <ng-template let-aplicacao pTemplate="item">
                    {{aplicacao.codigo}} {{aplicacao.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <img src="assets/img/global/sort_asc_az.png" alt="img" height="22" width="22"> <span
            class="text-black-50 font-weight-light"> Ordem de impressão </span>
          <hr />
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord1" label="Ordem de data" [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord2" label="Ordem de número da conta bancária"
                [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord3" label="Ordem classificação conta contábil"
                [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>